import styled from "styled-components";

import bg from "../../assets/images/sky.svg";
import {device} from "../../utils/mediaQueries";
import fonts from "../../utils/fonts";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
`;

export const Background = styled.div`
  background: url(${bg}) center/cover no-repeat;
  position: absolute;
  inset: 0;
  z-index: -1;
`;

export const Content = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  text-align: center;
  padding: 20px;
`;

export const Logo = styled.img`
  @media ${device.mobile} {
    width: 100px;
  }
`;

export const Title = styled.h1`
  ${fonts.lato.headingH1}
  font-size: 48px;
  color: white;
  margin-bottom: 16px;

  @media ${device.mobile} {
    font-size: 32px;
  }
`;

export const Subtitle = styled.p`
  ${fonts.lato.paragraph}
  font-size: 18px;
  color: white;
  margin-bottom: 32px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
`;
